"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ListMixin = require("../../mixins/components/ListMixin");
var _ListItem = require("../ListItem/ListItem");
var _excluded = ["appearance", "as"];
/**
 * A simple container component for vertical groupings of related content.
 * See `Table` for complex content or various font sizing and spacing requirements.
 *
 * @subcomponents [`List.Item`]
 * @since 8.14.0
 */
var List = /*#__PURE__*/(0, _styledComponents.default)( /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var appearance = _ref.appearance,
    as = _ref.as,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var Component =
  // eslint-disable-next-line no-nested-ternary
  typeof as !== 'undefined' ? as : appearance === 'number' ? 'ol' : 'ul';
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    ref: ref
  }, rest));
})).withConfig({
  displayName: "List",
  componentId: "c11n-8-107-0__sc-1smrmqp-0"
})(["", ""], _ListMixin.ListMixin);
exports.List = List;
List.displayName = 'List';
List.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The type of list to display.
   */
  appearance: _propTypes.default.oneOf(['bullet', 'number', 'horizontalTable', 'none']),
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   *
   * By default, this is determined by prop `appearance`, a `<ol>` element with `number`
   * and `<ul>` element with the rest prop values. But we allow special cases.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any
} : {};
List.defaultProps = {
  appearance: 'bullet'
};
List.Item = _ListItem.ListItem;

/** @component */